import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import { navigate } from "gatsby"

export const onRouteUpdate = ({ location }) => {
  const redirectPaths = [
    "/recruit/recruit-dummy",
  ]
  // リダイレクト
  if (redirectPaths.some(path => location.pathname.startsWith(path))) {
    navigate("/", { replace: true })
    return
  }

  // IntersectionObserver
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".marker, .fadeInUp")

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach(el => observer.observe(el))
  }
}
